import React from "react";

const SVG = ({
  width = "100%",
  className = "",
  viewBox = "0 0 16 16",
  color = "#6B708B",
}) => (
  <svg
    width={width}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g fill="none" fill-rule="evenodd">
      <path d="M0 0h16v16H0z" />
      <path
        stroke={color}
        stroke-width="1.333"
        stroke-linecap="round"
        stroke-linejoin="round"
        d="m6 10 4-4M7.333 4l.309-.357a3.334 3.334 0 1 1 4.714 4.714l-.356.31M8.667 12l-.265.356a3.379 3.379 0 0 1-4.751 0 3.315 3.315 0 0 1 0-4.714L4 7.333"
      />
    </g>
  </svg>
);

export default SVG;
